<template>
  <div>
    <BidApplyDetail
      v-if="Number(bizType) === 1"
      :bizWebId="bizWebId"
      :bizType="bizType"
    />

    <IntentLeaseDetail
      v-else-if="Number(bizType) === 2"
      :bizWebId="bizWebId"
      :bizType="bizType"
    />

    <div v-else class="empty-wrap">
      <div class="empty-icon">
        <i class="fas fa-folder-open"></i>
      </div>

      <div class="empty-title">相关项目已下架</div>

      <div class="empty-desc">当前项目可能已下架或停止展示</div>

      <button class="empty-btn" @click="$router.push('/')">返回首页</button>
    </div>
  </div>
</template>

<script>
import BidApplyDetail from "./bidApply/BidApplyDetail.vue";
import IntentLeaseDetail from "./intentLease/IntentLeaseDetail.vue";

export default {
  name: "HouseDetailIndex",

  components: {
    BidApplyDetail,
    IntentLeaseDetail,
  },

  props: {
    bizWebId: {
      type: String,
      required: true,
    },
    bizType: {
      type: [String, Number],
      required: true,
    },
  },
};
</script>

<style scoped>
.empty-wrap {
  min-height: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #fafafa;
}

.empty-icon {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: #f0f2f5;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.empty-icon i {
  font-size: 42px;
  color: #bfbfbf;
}

.empty-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.empty-desc {
  font-size: 14px;
  color: #999;
  margin-bottom: 30px;
}

.empty-btn {
  border: none;
  background: #1677ff;
  color: white;
  padding: 10px 30px;
  border-radius: 4px;
  cursor: pointer;
}

.empty-btn:hover {
  opacity: .9;
}
</style>